<template>
    <div class="builder-align">
        <p>{{ t("letter-builder.align") }}:</p>
        <div class="builder-align__wrapper">
            <div class="builder-align__elem" :class="{ active: type === cases.left }" @click="setType(cases.left)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.83203 9.99984L14.1654 9.99984M5.83203 9.99984L9.16536 6.6665M5.83203 9.99984L9.16536 13.3332"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="builder-align__elem" :class="{ active: type === cases.center }" @click="setType(cases.center)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 10L2 10M8 10L5.6 8M8 10L5.6 12"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M12 10L18 10M12 10L14.4 8M12 10L14.4 12"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path d="M10 2V18" stroke="#323030" stroke-linecap="round" />
                </svg>
            </div>
            <div class="builder-align__elem" :class="{ active: type === cases.right }" @click="setType(cases.right)">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.1641 9.99984L5.83073 9.99984M14.1641 9.99984L10.8307 6.6665M14.1641 9.99984L10.8307 13.3332"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>

            <div
                v-if="cases.justify"
                :class="{ active: type === cases.justify }"
                @click="setType(cases.justify)"
                class="builder-align__elem"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M2 10L8 10M2 10L4.4 8M2 10L4.4 12"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M18 10L12 10M18 10L15.6 8M18 10L15.6 12"
                        stroke="#323030"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path d="M10 2V18" stroke="#323030" stroke-linecap="round" />
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BuilderAlign",
    components: {},
    mixins: [],
    props: {
        types: {
            type: Array,
            default: () => ["flex-start", "center", "flex-end", "space-between"]
        },
        type: {
            type: String,
            default: "center"
        }
    },
    model: {
        prop: "type",
        event: "update"
    },
    computed: {
        cases() {
            const [left, center, right, justify] = this.types

            return {
                left,
                center,
                right,
                justify
            }
        }
    },
    methods: {
        setType(type) {
            this.$emit("update", type)
        }
    }
}
</script>
<style lang="scss" scoped>
.builder-align {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: Inter, sans-serif;
    color: #323030;
    font-size: 14px;
    font-weight: 400;
    line-height: 22.4px;

    &.gap-10 {
        grid-gap: 10px;
    }

    &__wrapper {
        display: flex;
        gap: 10px;
    }
    &__elem {
        display: flex;
        border: 1px solid #e0e0ec;
        border-radius: 3px;
        padding: 5px 15px;
        cursor: pointer;
        &:hover {
            background-color: #f2f7ff;
        }

        &.active {
            background-color: #3965ff;

            svg path {
                stroke: #ffffff;
            }
        }
    }
}
</style>
